function searchFilterFiltersForm() {
	$("#searchFilterFiltersReset").on("click", function(e) {
		e.preventDefault();
		$("#searchFilterFiltersForm select").val("selectTitle");
	});
}